<template>
  <div class="section notifications">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="section-block">
            <span class="title tw-text-black tw-uppercase">My Messages</span>
          </div>

          <div class="columns">
            <div class="column tw-text-right">
              <b-button
                v-if="
                  notifications.data &&
                    notifications.meta.total !== 0 &&
                    notifications.data.length !== 0
                "
                @click.prevent="markAllAsRead()"
                type="is-primary"
                size="sm"
                class="tw-text-sm"
                :disabled="isSubmitting || isAllRead"
                :loading="isSubmitting"
                >Mark all as read</b-button
              >
            </div>
          </div>

          <skeleton-loading v-if="isLoading" />
          <div class="list-group">
            <div
              v-for="(notification, index) in notifications.data"
              :key="notification + index"
              :class="[
                'columns group-item is-flex',
                {
                  '--unread': setUnreadStatus(notification),
                  '--unread-admin':
                    (notification.type === 'admin' ||
                      notification.type === 'message_leaders') &&
                    !notification.read
                }
              ]"
            >
              <div class=" is-one-fifth is-one-fifth-mobile item --icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  :class="[
                    'tw-mx-auto',
                    {
                      'tw-text-post-prayer tw-h-5 tw-w-5':
                        notification.type === 'admin' &&
                        notification.type === 'message_leaders',
                      'tw-h-6 tw-w-6':
                        notification.type !== 'admin' ||
                        notification.type !== 'message_leaders'
                    }
                  ]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <template v-if="notification.type === 'admin'">
                    <title>Admin</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </template>
                  <template v-if="notification.type === 'message_leaders'">
                    <title>Message Leaders</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </template>
                </svg>
              </div>
              <div class="item --text">
                <template v-if="notification.type === 'admin'">
                  <b-collapse
                    :open="false"
                    @open="routeToActivity(notification)"
                  >
                    <template #trigger="props1">
                      <b-icon
                        :icon="props1.open ? 'chevron-down' : 'chevron-up'"
                        size="is-small"
                        class="tw-text-post-prayer tw-mr-2"
                      >
                      </b-icon>
                      <a @click.prevent class="tw-text-post-prayer"
                        >Message from Admin</a
                      >
                    </template>
                    <div class="tw-mt-5 tw-pt-3 item-dropdown">
                      {{ notification.message }}
                    </div>
                  </b-collapse>
                </template>
                <template v-else-if="notification.type === 'message_leaders'">
                  <b-collapse
                    :open="false"
                    @open="routeToActivity(notification)"
                  >
                    <template #trigger="ml">
                      <b-icon
                        :icon="ml.open ? 'chevron-down' : 'chevron-up'"
                        size="is-small"
                        class="tw-text-post-prayer tw-mr-2"
                      >
                      </b-icon>
                      <a @click.prevent class="tw-text-post-prayer"
                        >{{ notification.header }}
                      </a>
                    </template>
                    <div class="tw-mt-5 tw-pt-3 item-dropdown">
                      {{ notification.message }}
                    </div>
                  </b-collapse>
                </template>
                <a
                  v-else
                  class="tw-cursor-pointer"
                  @click="routeToActivity(notification)"
                  >{{ notification.message }}</a
                >
              </div>
              <div
                class=" is-one-fifth is-one-fifth-mobile item --date"
                :title="formatDate(notification.created_at)"
              >
                {{ fromNow(notification.created_at) }}
              </div>
            </div>
            <b-pagination
              class="tw-mt-8"
              v-if="notifications.meta.total !== 0"
              @change="onPageChanged"
              :total="notifications.meta.total"
              :current.sync="notifications.meta.current_page"
              :per-page="notifications.meta.per_page"
              order="is-centered"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
            >
            </b-pagination>
            <div class="tw-text-gray-200 tw-text-center" v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-h-6 tw-w-6 tw-m-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
              You have no notifications yet
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { forEach } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  metaInfo: {
    title: 'Notifications'
  },
  data() {
    return {
      isAllRead: false,
      isLoading: false,
      isSubmitting: false,
      notifications: {
        meta: {
          current_page: 1,
          per_page: 15
        }
      }
    }
  },
  async mounted() {
    this.isLoading = true
    await this.getNotifications()
    await this.setCalendarTimezone(dayjs.tz.guess())
  },
  computed: {
    ...mapState({
      calendarOptions: state => state.calendar.options
    })
  },
  methods: {
    ...mapActions({
      getUnreadMessages: 'getUnreadMessages'
    }),
    ...mapMutations(['setCalendarTimezone']),

    formatDate(date) {
      return dayjs(date).format('DD/MM/YY HH:mm:ss Z UTC')
    },
    formatEventDate(date, format) {
      return dayjs(date)
        .tz(this.calendarOptions.timeZone)
        .format(format)
    },
    formatEventTime(time, format) {
      return dayjs(time)
        .tz(this.calendarOptions.timeZone)
        .format(format)
    },
    fromNow(date) {
      return dayjs(date).fromNow()
    },
    async getNotifications() {
      await this.$api
        .get(
          `/notifications?limit=${this.notifications.meta.per_page}&page=${this.notifications.meta.current_page}&filter[type]=message_leaders`
        )
        .then(({ data }) => {
          this.notifications = data
          this.checkAllNotifAsRead()
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async routeToActivity(notification) {
      switch (notification.type) {
        case 'message_leaders':
          await this.markNotifAsRead(notification.id)
          this.getNotifications()
          break
      }
    },
    async markNotifAsRead(id) {
      await this.$api.post(`/notifications/${id}/read`)
      this.getUnreadMessages()
    },
    async markNotifAsUnread(id) {
      await this.$api.post(`/notifications/${id}/unread`)
      this.getUnreadMessages()
    },
    async markAllAsRead() {
      this.isSubmitting = true
      await this.$api
        .post(`/notifications/mark-all-read?filter[type]=message_leaders`)
        .then(() => {
          this.getNotifications()
          this.getUnreadMessages()
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    async onPageChanged(page) {
      this.notifications.meta.current_page = page
      await this.getNotifications()
      await this.getUnreadMessages()
    },
    setUnreadStatus(notification) {
      if (notification.read) {
        return false
      } else {
        return (
          notification.type !== 'admin' &&
          notification.type !== 'message_leaders'
        )
      }
    },
    checkAllNotifAsRead() {
      forEach(this.notifications.data, data => {
        this.isAllRead = data.read
        if (!data.read) {
          return false
        }
      })
    }
  }
}
</script>

<style></style>
